export default "__VITE_ASSET__fb8e7909__"